// Each zone pair has a price per vehicle; 0 means that vehicle doesn't serve
// the pair. Fields match order-service's zone price.
export const VEHICLE_PRICE_FIELDS = [
  { field: "motorcyclePrice", label: "Motorcycle" },
  { field: "bicyclePrice", label: "Bicycle" },
];

// A zone pair is priced once in either direction, so the key ignores direction.
export const pairKey = (a, b) => [String(a), String(b)].sort().join("::");
